import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import UPMappingHitlistRowHeader from 'client/components/UPMappingHitlist/UPMappingHitlistRowHeader';
import UPAdminProcessAddressFormConnected from 'client/components/UPAdminProcessAddressFormConnected/UPAdminProcessAddressFormConnected';

import './UPMappingHitlistRow.less';

const UPMappingHitlistRow = ({
  hitlistTask,
  currentUser,
  onRowClick,
  onButtonClick,
  onUpdate,
  isExpanded,
}) => {
  return (
    <div styleName={classnames('row', { expanded: isExpanded })}>
      <UPMappingHitlistRowHeader
        hitlistTask={hitlistTask}
        currentUser={currentUser}
        onButtonClick={onButtonClick}
        onRowClick={onRowClick ? () => onRowClick(!isExpanded) : null}
      />
      {isExpanded && (
        <div styleName="body">
          <UPAdminProcessAddressFormConnected
            addressId={hitlistTask.address.id}
            onUpdate={onUpdate}
            markAsRequiredEnabled
            addressRequiredUtilityTypes={hitlistTask.addressRequiredUtilityTypes}
          />
        </div>
      )}
    </div>
  );
};

UPMappingHitlistRow.propTypes = {
  hitlistTask: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  onButtonClick: PropTypes.func.isRequired,
  onUpdate: PropTypes.func,
  onRowClick: PropTypes.func,
};

export default UPMappingHitlistRow;
